// src/components/holaveciLocal/AvisoMensualidad.js
//
// D-24 — Aviso de mensualidad pendiente (dentro del plazo) sobre cualquier
// pantalla del POS, con el pago en un diálogo. Cuando ya venció, el layout
// muestra la pantalla de suspensión en su lugar.

import React, { useCallback, useEffect, useState } from 'react';
import {
  Alert, Button, Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import { mensualidad as apiMensualidad } from '../../api/holaveciLocalApi';
import { useApp } from '../../context/AppContext';
import PagoLocalWompi from './PagoLocalWompi';

const MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
const cop = (n) => (n ?? 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
const fechaHora = (iso) => {
  if (!iso) return '';
  const d = new Date(/Z$|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`);
  return d.toLocaleString('es-CO', { timeZone: 'America/Bogota', weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
};

export default function AvisoMensualidad() {
  const { notify } = useApp();
  const [estado, setEstado] = useState(null);
  const [abierto, setAbierto] = useState(false);

  const cargar = useCallback(async () => {
    try { setEstado(await apiMensualidad.estado()); }
    catch { setEstado(null); }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const f = estado?.factura;
  if (!f || estado.bloqueado || f.estado === 'PAGADA') return null;

  return (
    <>
      <Alert
        severity="warning"
        sx={{ mb: 2 }}
        action={<Button color="inherit" size="small" variant="outlined" onClick={() => setAbierto(true)}>Pagar ahora</Button>}
      >
        Tu mensualidad de <b>{MESES[(f.periodoMes || 1) - 1]}</b> por <b>{cop(f.total)}</b> vence el{' '}
        <b>{fechaHora(f.fechaLimitePago)}</b>. Si no se paga, HolaVeci se suspende.
      </Alert>

      <Dialog open={abierto} onClose={() => setAbierto(false)} fullWidth maxWidth="sm">
        <DialogTitle>Pagar mensualidad</DialogTitle>
        <DialogContent dividers>
          <PagoLocalWompi
            modo="mensualidad"
            onPagado={() => { setAbierto(false); notify('Pago confirmado. ¡Gracias!', 'success'); cargar(); }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAbierto(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
